import request from "@/utils/request";
// import {formatSourceDataFromSever} from "@/views/BCSProduct/style-xml-manager";



export function getScreen({userId}) {
    return request({url: `/appi/Screen/Screen?userId=${userId}`})
}